/**
 * Cấu hình URL.
 * URL API không đóng cứng lúc build. Trình duyệt đọc public/config.js (trên server là dist/config.js).
 */

export function layApiBaseUrl(): string {
  const tuCuaSo =
    typeof window !== 'undefined' ? window.__QUEUE_CONFIG__?.API_BASE_URL : undefined;
  const giaTri = (tuCuaSo || '/api').trim().replace(/\/+$/, '');
  return giaTri || '/api';
}

// Link QR, lấy đúng domain trình duyệt đang mở
export const FRONTEND_BASE_URL =
  typeof window !== 'undefined' ? window.location.origin : '';

const config = {
  api: {
    get baseUrl() {
      return layApiBaseUrl();
    },
    timeout: 30000,
  },
  frontend: {
    baseUrl: FRONTEND_BASE_URL,
  },
  // Trang không cần đăng nhập
  publicPaths: [
    '/queue',
    '/qr-queue',
    '/m-queue',
    '/tv',
    '/counter',
    '/user/login',
    '/user/register',
    '/user/register-result',
  ],
  // API không gắn header Authorization
  noAuthEndpoints: ['/auth/login', '/auth/register', '/public/'],
};

export default config;
